module.exports = __webpack_public_path__ + "static/media/olake-logo.12312918.svg";